import { createFileRoute } from "@tanstack/react-router"
import { AmphoraAuthModal } from "modules/settings/components/integrations/amphora/AmphoraAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/amphora/connect")({
  component: AmphoraAuthModal,
})
